const ProductSidebar = {
  init() {
    ProductSidebar.handleInitEvents();
    ProductSidebar.handleSearchCategory();
    ProductSidebar.handleOpenProductSidebar();
  },

  handleInitEvents() {
    const $form = $(".bb-product-form-filter");
    if ($form.length) {
      $form.on("change", function () {
        $('[name="page"]').val(1);
        $('[name="page"]').data("value", 1);
        this.submit();
      });
    }

    $(".js-product-sidebar-clear").on("click", function () {
      const $section = $(this).closest(".product-category-sidebar__block");
      $section.find("input[type=checkbox]").prop("checked", false);
      if ($section.find(".bb-product-price-filter").length) {
        const min = $section.find(".price-slider").data("min") || 0;
        const max = $section.find(".price-slider").data("max") || 0;
        $section.find("input[name=min_price]").val(min);
        $section.find("input[name=max_price]").val(max);
        EcommerceApp.initPriceFilter();
      }
      $('[name="page"]').val(1);
      $('[name="page"]').data("value", 1);
      $form.submit();
    });

    $(".js-product-sidebar-clear-all").on("click", function () {
      $form.find("input[type=checkbox]").prop("checked", false);
      if ($form.find(".bb-product-price-filter").length) {
        const min = $form.find(".price-slider").data("min") || 0;
        const max = $form.find(".price-slider").data("max") || 0;
        $form.find("input[name=min_price]").val(min);
        $form.find("input[name=max_price]").val(max);
        EcommerceApp.initPriceFilter();
      }
      $('[name="page"]').val(1);
      $('[name="page"]').data("value", 1);
      $form.submit();
    });

    $(".ps-select-shop-sort").on("change", function (e) {
      $(document).find(".bb-product-form-filter").find("input[name=sort-by]").val($(e.currentTarget).val());
      $(document).find(".bb-product-form-filter").trigger("submit");
    });
  },

  handleSearchCategory() {
    $(document).on("keyup", ".js-product-category-search", function () {
      const query = $(this).val().toLowerCase();

      $(".js-product-category-item").each(function () {
        const categoryName = $(this).data("name").toLowerCase();
        if (categoryName.includes(query)) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
    });
  },

  handleOpenProductSidebar() {
    $(document).on("click", ".js-open-product-sidebar", function () {
      $(".product-category__sidebar").addClass("active");
      $(".screen-darken").addClass("active");
    });

    $(document).on("click", ".screen-darken", function () {
      $(".product-category__sidebar").removeClass("active");
      $(".screen-darken").removeClass("active");
    });

    $(document).on("click", ".js-close-product-sidebar", function () {
      $(".product-category__sidebar").removeClass("active");
      $(".screen-darken").removeClass("active");
    });
  },
};

$(document).ready(() => {
  ProductSidebar.init();
});
